module.exports = __webpack_public_path__ + "pic_bizny_web_02@2x.png?5b9187a91a4837d875879d8841b234df";